
import { Integration, TrendyolCredentials } from "@/dtos/Integration";
import { defineComponent, ref, Ref, onMounted } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { Modal } from "bootstrap";
import { Actions } from "@/store/enums/StoreEnums";

import { IntegrationProduct } from "@/dtos/IntegrationProduct";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { IIntegrationElement } from "@/dtos/IIntegrationElement";
import CreateUpdateIntegration from "@/components/modals/forms/CreateUpdateIntegration.vue";


export default defineComponent({
  name: "kt-widget-5",
  components: { CreateUpdateIntegration },
  props: {
    widgetClasses: String,
    data: Array
  },
  emits: ["need-refresh"],
  setup(props,ctx) {
    const store = useStore();
    const router = useRouter();
    const selectedIntegration: Ref<Integration> = ref({});

    // Make sure we know the plan's integration limit before offering "add".
    onMounted(() => {
      store.dispatch(Actions.GET_SUBSCRIPTION).catch(() => undefined);
    });

    // Opens the add-integration modal, but first enforces the plan limit and
    // offers an upgrade when the account is already at its cap.
    const onAddNew = () => {
      const sub = store.getters.getSubscription || {};
      const limit = sub.integrationLimit; // null/undefined = unlimited
      const count = (props.data as unknown[])?.length ?? sub.integrationCount ?? 0;
      const blocked =
        sub.canAddIntegration === false ||
        (limit !== null && limit !== undefined && count >= limit);
      if (blocked) {
        Swal.fire({
          title: "Entegrasyon limiti doldu",
          text: `Planınız ${limit ?? 3} entegrasyona kadar izin veriyor. Daha fazlası için Sınırsız pakete geçin.`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Sınırsız Pakete Geç",
          cancelButtonText: "Vazgeç",
        }).then((r) => {
          if (r.value) router.push({ name: "billing" });
        });
        return;
      }
      // Preserve the existing pattern: the child reads `selectedIntegration.value`.
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (selectedIntegration.value as any).value = { isNew: true, credentials: {} };
      const el = document.getElementById("kt_modal_create_api_key");
      if (el) Modal.getOrCreateInstance(el).show();
    };
    const deleteIntegration = async (item: Integration) => {
      Swal.fire({
        title: "Emin misiniz?",
        text: `${item.id} numaralı ${IIntegrationElement.friendlyName({integrationId:item.id,integrationType:item.integrationType})} entegrasyonunu silmek istediğinize emin misiniz ? Bu işlem geri alınamaz.`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Evet Sil!",
        cancelButtonText : "Vazgeç",
        showLoaderOnConfirm: true,
        preConfirm: ()=> {

        Swal.showLoading();
        return store.dispatch(Actions.DELETE_INTEGRATION, item).then((r) => {
        
          Swal.fire({
            title: "Silindi!",
            text: "Entegrasyon başarıyla silindi!",
            icon: "success"
          }).then(() => {
            ctx.emit("need-refresh");
          });
        }).catch((e)=>{
          Swal.fire({
            title: "Hata",
            text: "Silinirken sorun çıktı",
            icon: "error",
            confirmButtonText: "Tamam"
          });
        
      });

        }
      });
    };

    return { Integration, IntegrationProduct, selectedIntegration, deleteIntegration, onAddNew }
  }
});
